import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import Root from './src/root';


registerRootComponent(Root);
